<template>
    <div style="width: 100%; height: 100%; text-align: left;">
        <v-treeview
                :search="search"
                open-all
                :activatable="false"
                :dense="true"
                :hoverable="true"
                :items="itemsSafe"
                :open-on-click="true"
                :rounded="true"
                :selectable="false"
                @input="val=>this.itemModel=val"
                @update:active="val=>this.itemActive=val"
                @update:open="val=>this.itemOpen=val"
                color="primary"
                selected-color="success"
        >
            <template #label="{ item, leaf, selected, indeterminate, active, open, }">
                <template v-if="item.deleted()">
                    <span style="color: #ddd">{{item.name}}</span>
                    <v-btn @click.stop="$emit('click:restore', item)" icon>
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <system-permission-edit-button
                            :item="item"
                    ></system-permission-edit-button>
                    <v-btn @click.stop="$emit('click:delete-permanently', item)" icon>
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
                <template v-else>
                    <span>{{item.name}}</span>
                    <system-permission-append-button
                            :item="item"
                            :type="type"
                    >
                    </system-permission-append-button>
                    <system-permission-edit-button
                            :item="item"
                    >
                    </system-permission-edit-button>
                    <v-btn @click.stop="$emit('click:delete', item)" icon>
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </template>
        </v-treeview>
    </div>
</template>

<script>
    import SystemPermissionAppendButton from "@/views/permission/manage/SystemPermissionAppendButton";
    import SystemPermissionEditButton from "@/views/permission/manage/SystemPermissionEditButton";
    export default {
        name: "SystemPermissionTreeView",
        components: {SystemPermissionEditButton, SystemPermissionAppendButton},
        props: {
            items: {
                type: Array,
                default: () => [],
            },
            search: {
                type: String,
                default: "",
            },
            type: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                itemModel: undefined,
                itemActive: undefined,
                itemOpen: undefined,
            }
        },
        computed: {
            itemsSafe() {
                return this.items || {};
            },
        },
    }
</script>

<style scoped>

</style>